import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {connect} from "react-redux";
import {networkDeviceContentActions} from "../../../actions/network-device-content.actions";
import {networkDeviceActions} from "../../../actions/network-device.actions";
import {Link} from "react-router-dom";
import {Alert, ProgressBar, Spinner} from "react-bootstrap";
import {networkDeviceContentService} from "../../../services/network-device-content.service";
import axios from "axios";
import HilightReactResumableJs from "../../../components/HilightReactResumableJs";
import {exhibitionScenarioActions} from "../../../actions/exhibition-scenario.actions";
import {userHelper} from "../../../helpers/user-helper";
import NetworkDeviceContentLauncher from "./_components/NetworkDeviceContentLauncher";
import {FormHandler} from "../../../core/common/form-handler";
import NetworkDeviceContentSwitcher from "./_components/NetworkDeviceContentSwitcher";

class NetworkDeviceContentEditPage extends Component {

    state = {
        form: {
            id: null,
            networkDeviceId: '',
            fileUpdated: '',
            filePath: '',
            package: '',
            fileName: '',
            label: '',
            exePath: '',
            exeArgs: '',
            contentLocalDirPath: '',
            isDefault: false,
            useResolutionCheck: false,
            width: '',
            height: '',
            useShellExecute: false,
            createNoWindow: false,
            applicationStartDelay: '',
            defaultApp: null,
            exhibitionScenarioId: null,
            launcherId: null,
            launcherItems: [],
            switcherItems: []
        },
        params: {
            loading: false,
            progress: 0,
        }
    };

    componentDidMount() {
        const {dispatch} = this.props;
        const networkDeviceId = this.props.match.params.id;
        const contentId = this.props.match.params.contentId;

        dispatch(networkDeviceActions.getNetworkDeviceSimpleInfo(networkDeviceId));
        dispatch(networkDeviceContentActions.getDefaultApp());
        dispatch(networkDeviceContentActions.getNetworkDeviceContentByContentId(contentId));
        dispatch(exhibitionScenarioActions.getDropdownListExhibitionScenario());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        const {singleNetworkDeviceContent} = this.props;

        if (prevProps.singleNetworkDeviceContent !== singleNetworkDeviceContent && singleNetworkDeviceContent !== null) {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    ...singleNetworkDeviceContent,
                    isPrimaryApp: singleNetworkDeviceContent.isPrimaryApp !== null ? singleNetworkDeviceContent.isPrimaryApp : ''
                }
            });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        networkDeviceContentService.editNetworkDeviceContent(this.state.form)
            .then(
                (res) => {
                    console.log(res);
                    // TODO alert success / error info about request status
                    this.props.history.push(`/panel/network-device/content/${this.state.form.networkDeviceId}`)
                },
                (error) => {
                    console.log(error);
                }
            );
    };

    handleOnChangeLauncherItem = (data) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                launcherItems: data
            }
        })
    }

    render() {
        const {t, simpleDeviceInfo, defaultApps, exhibitionScenarioDropdown, user } = this.props;
        const userId = user.Id;

        // using scenario
        const useScenario  = userHelper.getUseExhibitionScenario(user) && simpleDeviceInfo?.useScenario;


        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device' },
            { value: 'network-device-content', path: '#' },
            { value: simpleDeviceInfo?.label, path: '/panel/network-device/content/' + simpleDeviceInfo?.id },
            { value: 'edit-content', path: '#' },
        ];

        const selectDom = defaultApps?.length > 0 ?
            ( defaultApps.map((app, idx) => (<option key={idx} value={JSON.stringify(app)}>{t(app.label)}</option>))) :
            ( <option value={null}>Loading ...</option> );

        const selectExhibitionScenario = exhibitionScenarioDropdown?.length > 0 ?
            (exhibitionScenarioDropdown.map((scenario, idx) => (<option key={idx} value={scenario.id}> {scenario.label} </option>))) :
            (<option value={null}>Loading ...</option>);


        return (
            <div>
                <BreadcrumbExtend items={breadcrumb} />
                <div className="row">
                    <div className="col-md-12">
                        <h4>{ t('edit-content-on-device') }:  <b>{ simpleDeviceInfo?.label }</b></h4>
                        <h3 className='font-italic'>{ this.state.form.fileName }</h3>
                        <div className="card">
                            <div className="card-header">
                                <div className="button-group">
                                    { simpleDeviceInfo ? (
                                        <Link
                                            to={"/panel/network-device/content/" + simpleDeviceInfo?.id }
                                            className={"btn btn-secondary float-right"}
                                        >
                                            <i className="fas fa-undo"> </i>
                                            <span> {t('back-to-list')} </span>
                                        </Link>
                                    ) : (
                                        <div className="float-right">
                                            <Spinner animation={"border"} />
                                        </div>
                                    ) }

                                </div>
                            </div>

                            <div className="card-body">
                                <form className="row" encType="multipart/form-data" onSubmit={this.handleSubmit}>

                                    { !this.state.params.loading ||  (
                                        <Alert variant={"warning"} className="col-md-12" >
                                            <Spinner animation={"border"} size={"md"} variant={"success"} />
                                            <p className="font-weight-bold">{t('waiting-upload-msg')}</p>
                                            <p className="my-1">{t('waiting-upload-msg2')}</p>
                                            <ProgressBar now={this.state.params.progress} label={`${this.state.params.progress}%`} animated />
                                        </Alert>
                                    ) }

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="col-form-label"> {t('app-type')} </label>
                                            <select
                                                className="form-control"
                                                name="defaultApp"
                                                value={JSON.stringify(this.state.form.defaultApp) || ''}
                                                onChange={(e) => FormHandler.onSelectJson(e, this)}
                                            >
                                                { !selectDom || selectDom }
                                            </select>
                                        </div>
                                        { this.state.form.defaultApp?.label !== "launcher" && this.state.form.defaultApp?.label !== "switcher" ? (
                                            <React.Fragment>
                                                <div className="form-group">
                                                    <HilightReactResumableJs
                                                        uploaderID={user.Id}
                                                        dropTargetID="myDropTarget"
                                                        filetypes={["zip", "7zip"]}
                                                        maxFileSize="107374182400"
                                                        fileAddedMessage="Started!"
                                                        completedMessage="Complete!"
                                                        service="/api/networkDevicesContent/uploadFile"
                                                        textLabel={<i className="fas fa-upload" /> }
                                                        previousText={ t('upload-content-package') }
                                                        forceChunkSize={true}
                                                        disableDragAndDrop={true}
                                                        onFileSuccess={(file, message) => {
                                                            this.setState({
                                                                ...this.state,
                                                                form: {
                                                                    ...this.state.form,
                                                                    fileUpdated: true,
                                                                    fileName: file.file.name,
                                                                    filePath: file.name,
                                                                },
                                                                params: {
                                                                    ...this.state.params,
                                                                    loading: false,
                                                                }
                                                            });
                                                        }}
                                                        onFileAdded={(file, resumable) => {
                                                            axios.post(`/api/networkdevicescontent/StartSession/${userId}`, {
                                                                chunkSize: resumable.opts.chunkSize,
                                                                totalSize: file.size,
                                                                fileName: file.fileName,
                                                            })
                                                                .then(
                                                                    (res) => {
                                                                        resumable.opts.sessionId = res.data.sessionId;
                                                                        resumable.opts.target = `/api/networkdevicescontent/UploadFileChunk/${userId}/${res.data.sessionId}`;
                                                                        resumable.upload();
                                                                        // set state loading start
                                                                        this.setState({
                                                                            ...this.state,
                                                                            form: {
                                                                                ...this.state.form,
                                                                                sessionId: resumable.opts.sessionId,
                                                                            },
                                                                            params: {
                                                                                ...this.state.params,
                                                                                loading: true
                                                                            }
                                                                        });
                                                                    },
                                                                    (error) => {
                                                                        console.log(error)
                                                                    }
                                                                );
                                                        }}
                                                        onProgressUpload={(progress) => {
                                                            this.setState({
                                                                ...this.state,
                                                                params: {
                                                                    ...this.state.params,
                                                                    progress: Math.ceil(progress)
                                                                }
                                                            });
                                                        }}
                                                        maxFiles={1}
                                                        startButton={true}
                                                        pauseButton={true}
                                                        cancelButton={true}
                                                        onStartUpload={() => {
                                                            console.log("Start upload");
                                                        }}
                                                        onPauseUpload={() =>{
                                                            this.inputDisable = false;
                                                        }}
                                                        onResumeUpload={() => {
                                                            this.inputDisable = true;
                                                        }}
                                                        onCancelUpload={() => {
                                                            this.setState({
                                                                ...this.state,
                                                                params: {
                                                                    ...this.state.params,
                                                                    loading: false,
                                                                    progress: 0
                                                                }
                                                            });
                                                        }}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="fileName" className="col-form-label"> {t('file-name')} </label>
                                                    <input
                                                        readOnly
                                                        type="text"
                                                        className="form-control"
                                                        id="fileName"
                                                        name="fileName"
                                                        value={this.state.form.fileName || ''}
                                                    />
                                                </div>
                                            </React.Fragment>
                                        ): <></> }

                                        { useScenario ? (
                                            <div className="form-group">
                                                <label htmlFor="exhibitionScenario" className="col-form-label"> {t('exhibition-scenario')} </label>
                                                {exhibitionScenarioDropdown?.length === 0 ? (
                                                        <div className="alert alert-warning">
                                                            {t('exhibition-scenario-no-content')}
                                                        </div>
                                                    ) :
                                                    (
                                                        <select className="form-control" name="exhibitionScenarioId"
                                                                value={this.state.form.exhibitionScenarioId || ""}
                                                                onChange={(e) => FormHandler.onSelectBasic(e, this)}>
                                                            <option value="null">{t('exhibition-scenario-default')}</option>
                                                            {!selectExhibitionScenario || selectExhibitionScenario}
                                                        </select>
                                                    )
                                                }
                                            </div>
                                        )  : (<React.Fragment/>) }

                                        <div className="form-group">
                                            <label htmlFor="label" className="col-form-label"> {t('label')} </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="label"
                                                name="label"
                                                onChange={(e) => FormHandler.onChangeInput(e, this)}
                                                value={this.state.form.label || ''}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="exeArgs" className="col-form-label" > {t('arguments')} </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="exeArgs"
                                                name="exeArgs"
                                                onChange={(e) => FormHandler.onChangeInput(e, this)}
                                                value={this.state.form.exeArgs || ''}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="isDefault" className="col-form-label"> {t('is-default')} </label>
                                            <input
                                                type="checkbox"
                                                className="form-check"
                                                name="isDefault"
                                                id="isDefault"
                                                onChange={(e) => FormHandler.onChangeCheckbox(e, this)}
                                                checked={this.state.form.isDefault || false}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="useResolutionCheck" className="col-form-label"> {t('use-resolution-check')} </label>
                                            <input
                                                type="checkbox"
                                                className="form-check"
                                                name="useResolutionCheck"
                                                id="useResolutionCheck"
                                                onChange={(e) => FormHandler.onChangeCheckbox(e, this)}
                                                checked={this.state.form.useResolutionCheck || false}
                                            />
                                        </div>

                                        { !this.state.form.useResolutionCheck || (
                                            <div className="row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="width" className="col-form-label"> {t('width')} </label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        id="width"
                                                        name="width"
                                                        onChange={(e) => FormHandler.onChangeInput(e, this)}
                                                        value={this.state.form.width || ''}
                                                        required
                                                    />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="height" className="col-form-label"> {t('height')} </label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        id="height"
                                                        name="height"
                                                        onChange={(e) => FormHandler.onChangeInput(e, this)}
                                                        value={this.state.form.height || ''}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        <div className="form-group">
                                            <label htmlFor="useShellExecute" className="col-form-label"> {t('use-shell-execute')} </label>
                                            <input
                                                type="checkbox"
                                                className="form-check"
                                                name="useShellExecute"
                                                id="useShellExecute"
                                                onChange={(e) => FormHandler.onChangeCheckbox(e,this)}
                                                checked={this.state.form.useShellExecute || false}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="createNoWindow" className="col-form-label"> {t('create-no-window')} </label>
                                            <input
                                                type="checkbox"
                                                className="form-check"
                                                name="createNoWindow"
                                                id="createNoWindow"
                                                onChange={(e) => FormHandler.onChangeCheckbox(e,this)}
                                                checked={this.state.form.createNoWindow || false}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="applicationStartDelay" className="col-form-label"> {t('application-start-delay')} </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="applicationStartDelay"
                                                id="applicationStartDelay"
                                                onChange={(e) => FormHandler.onChangeInput(e, this)}
                                                value={this.state.form.applicationStartDelay || ''}
                                            />
                                        </div>
                                    </div>

                                    <NetworkDeviceContentLauncher
                                        show={this.state.form.defaultApp?.label === "launcher"}
                                        edit={true}
                                        networkDeviceId={this.state.form.networkDeviceId}
                                        launcherItems={this.state.form.launcherItems}
                                        setLauncherItems={(data) => this.handleOnChangeLauncherItem(data)}
                                    />

                                    <NetworkDeviceContentSwitcher
                                        show={this.state.form.defaultApp?.label === "switcher"}
                                        networkDeviceId={this.state.form.networkDeviceId}
                                        switcherItems={this.state.form.switcherItems}
                                        setSwitcherItems={(data) => FormHandler.onChangeStateKey(data, "switcherItems", this)}
                                    />

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <button type="submit" className="btn btn-primary" disabled={this.state.params.loading}>
                                                <i className="fas fa-upload"> </i>
                                                <span> {t('save-changes')} </span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { singleNetworkDeviceContent } = state.networkDeviceContentReducer;
    const { defaultApps } = state.networkDeviceContentReducer;
    const { simpleDeviceInfo } = state.networkDeviceReducer;
    const { exhibitionScenarioDropdown } = state.exhibitionScenarioReducer;
    const { user } = state.authenticationReducer;
    return {
        singleNetworkDeviceContent,
        simpleDeviceInfo,
        user,
        defaultApps,
        exhibitionScenarioDropdown
    }
};
export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceContentEditPage));
